import {
  ControlWithinTree,
  NestedControlThatWasChanged
} from "@/types/controls";
import { getControlLabelWithAncestorsLabelsFirst } from "@/lib/controls/utils";
import { generateSnapshotLabel } from "@/lib/undo/snapshot-labels/utils";
import { GenericStorePropertyChange } from "@/types/store-property-change";
import { CONTROL_CLEAR_VALUE } from "@/lib/controls/values";
import {
  SnapshotLabelAction,
  SnapshotLabelActionAndSubject
} from "@/types/snapshot";

export function generateGenericStorePropertyChangeSnapshotLabelBasingOnChangedControl(
  actionAndSubject: SnapshotLabelActionAndSubject,
  controlWithinTree: ControlWithinTree,
  nestedControlThatWasChanged?: NestedControlThatWasChanged
): string {
  const controlLabels =
    getControlLabelWithAncestorsLabelsFirst(controlWithinTree);

  // TODO in theory there may be multiple levels of nested controls (due to the fact NestedControlThatWasChanged is recursive), only one level is handled as of now
  if (nestedControlThatWasChanged) {
    controlLabels.push(
      ...getControlLabelWithAncestorsLabelsFirst(nestedControlThatWasChanged)
    );
  }

  return generateSnapshotLabel(actionAndSubject, controlLabels);
}

export function getPropertyChangeSnapshotLabelAction(
  change: Omit<GenericStorePropertyChange, "meta">
): SnapshotLabelAction {
  return change.value === CONTROL_CLEAR_VALUE
    ? SnapshotLabelAction.CLEAR
    : SnapshotLabelAction.CHANGE;
}
